// extracted by mini-css-extract-plugin
export default {"marksPage":"Marks_marksPage__qOha-","filters":"Marks_filters__nzTaF","content":"Marks_content__mOIfC","marks":"Marks_marks__ppJa9","activity":"Marks_activity__XXZH1"};